import { useRef, useState, createContext, useContext, useCallback, useEffect } from 'react';
import type { ReactElement, ReactNode, RefObject } from 'react';
import DeviceOrientationListener from '../../util/DeviceOrientationListener';
import useEventListener from '../../hooks/useEventListener';
import { isDesktop } from '../../hooks/useIsDesktopDevice';

export interface DeviceOrientationContextType {
  isMobileLandscape: boolean;
}

const DeviceOrientationContext = createContext<DeviceOrientationContextType | undefined>(undefined);

export function useDeviceOrientationContext(): DeviceOrientationContextType | undefined {
  return useContext(DeviceOrientationContext);
}

export interface DeviceOrientationProps {
  children: ReactNode;
}

const deviceOrientationListener = new DeviceOrientationListener();

export function DeviceOrientation(props: DeviceOrientationProps): ReactElement {
  const deviceOrientationListenerRef = useRef(deviceOrientationListener);
  const [isMobileLandscape, setIsMobileLandscape] = useState(false);

  // @ts-ignore
  const handleOrientationChange = useCallback((event) => {
    setIsMobileLandscape(
      event.data.orientation === DeviceOrientationListener.landscape &&
        window.innerHeight < 536 &&
        !isDesktop,
    );
  }, []);

  useEventListener(
    DeviceOrientationListener.orientationChange as keyof HTMLElementEventMap,
    handleOrientationChange,
    deviceOrientationListenerRef as unknown as RefObject<HTMLElement | null>,
  );

  useEffect(() => {
    deviceOrientationListener.init();
  }, []);

  return (
    <DeviceOrientationContext.Provider
      value={{
        isMobileLandscape,
      }}
    >
      {props.children}
    </DeviceOrientationContext.Provider>
  );
}
